import { render, staticRenderFns } from "./fileBase64.vue?vue&type=template&id=8f8ad416&scoped=true&"
import script from "./fileBase64.vue?vue&type=script&lang=js&"
export * from "./fileBase64.vue?vue&type=script&lang=js&"
import style0 from "./fileBase64.vue?vue&type=style&index=0&id=8f8ad416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8ad416",
  null
  
)

export default component.exports